// 计时器提示音:用 Web Audio 现场合成,无需音频文件,也避开了 mp3 自动播放被拦的坑。
// 浏览器策略:AudioContext 初始为 suspended,需一次用户手势才能出声——这里在首次
// pointerdown/keydown/touchstart 时自动 resume;裁判点「开始计时」也会顺带解锁。

let ctx: AudioContext | null = null

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null
  if (!ctx) {
    const AC = window.AudioContext || (window as any).webkitAudioContext
    if (!AC) return null
    ctx = new AC()
  }
  return ctx
}

export function unlockAudio(): void {
  const c = getCtx()
  if (c && c.state === 'suspended') c.resume().catch(() => {})
}

// 单个音符:sine 波 + 快起快落包络,听感像清脆的「叮」
function beep(c: AudioContext, freq: number, startOffset: number, duration: number, peak = 0.25): void {
  const osc = c.createOscillator()
  const gain = c.createGain()
  osc.type = 'sine'
  osc.frequency.value = freq
  osc.connect(gain)
  gain.connect(c.destination)
  const t0 = c.currentTime + startOffset
  gain.gain.setValueAtTime(0.0001, t0)
  gain.gain.linearRampToValueAtTime(peak, t0 + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration)
  osc.start(t0)
  osc.stop(t0 + duration + 0.03)
}

// 进入「停止抓牌」的预警:两声下行短音,提示「快到点了,别再开新局」
export function playWarnChime(): void {
  const c = getCtx()
  if (!c) return
  if (c.state === 'suspended') c.resume().catch(() => {})
  beep(c, 880, 0, 0.25)
  beep(c, 660, 0.28, 0.38)
}

// 计时归零:三声上行「小号」+ 拉长收尾,抓耳报时
export function playEndChime(): void {
  const c = getCtx()
  if (!c) return
  if (c.state === 'suspended') c.resume().catch(() => {})
  beep(c, 660, 0, 0.22, 0.3)
  beep(c, 880, 0.24, 0.22, 0.3)
  beep(c, 1175, 0.48, 0.7, 0.35)
}

// 首次任意用户手势时解锁音频(一次即可)
if (typeof window !== 'undefined') {
  const events = ['pointerdown', 'keydown', 'touchstart']
  const handler = () => {
    unlockAudio()
    events.forEach((e) => window.removeEventListener(e, handler))
  }
  events.forEach((e) => window.addEventListener(e, handler, { passive: true }))
}
